import api from "./api";

import { buildQueryParams } from "../utils/buildQueryParams";

class LancamentosService {
  get(filters){
    const queryParams = buildQueryParams(filters);
    return api.get(`v1/api/product-launches?${queryParams}`);
  }

  getCategories(){
    return api.get(`v1/api/product-launches/product-launch-categories`);
  }
}

export default new LancamentosService();
